// @flow


import type {Node} from 'react';
import type {Game} from './types'

import React from 'react';
import UserRow from "./UserRow";
import "./GameRow.css";
import { useState, useEffect } from "react";
import ViewTracker from "./logger/ViewTracker";

import { useDispatch, useSelector } from 'react-redux';
import { logEvent } from './actions'

const useSendTrackingEvent = () => {
    const dispatch = useDispatch();
    return (user_id: string) => () => dispatch(logEvent(
        "user_circle_impression",
        {
            "container_module": "test",
            "user_id": user_id,
            "prior_module": "test"
        }
    ));
};

export default function GameRow({ game }: {game: Game}): Node {
    const [now_time, setNowTime] : [Date, (((Date) => Date)|Date) => void] = useState(new Date());


    useEffect(() => {
        setTimeout(() => setNowTime(new Date()), 1000)
    }, [now_time]);

    const last_move_time = new Date(game.last_move_time * 1000);

    // $FlowExpectedError Date - Date
    const diff_in_sec = (now_time - last_move_time) / 1000;
    const hours = Math.floor(diff_in_sec / 3600);
    const minutes = Math.floor((diff_in_sec - hours * 3600) / 60);
    const seconds = Math.floor((diff_in_sec - minutes * 60 - hours * 3600));

    const impression_log = useSendTrackingEvent();

    const user_components = game.players.map((user, idx) => {
        return <ViewTracker key={"some-unique-key-" + idx} onView={impression_log(user.id)}>
            <UserRow user={user} idx={idx} is_their_turn={game.current_turn_user.name === user.name} />
        </ViewTracker>
    });
    return <div className="gameRow">
        <div className="gameTitle">{game.name}</div>
        <div className="waitingLine">Waiting on {game.current_turn_user.name} for {hours} hours {minutes} minutes and {seconds} seconds </div>
        <div className="gameIconRow">
            {user_components}
        </div>
    </div>;
}